import axios from 'axios';

/* Inbox client. Mirrors api.js (same base URL, same Bearer token out of
   localStorage) but keeps its own axios instance so the inbox can evolve
   without touching the shared client. */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const apiEmails = axios.create({
  baseURL: API_BASE_URL,
});

apiEmails.interceptors.request.use(
  (config) => {
    let token = null;
    try {
      token = localStorage.getItem('access_token');
    } catch {
      token = null;
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/** GET /emails — newest first; domain_id filters on project_id, q on subject/sender, type on message type. */
export const listEmails = async ({ domainId, q, type, page = 1, perPage = 50 } = {}) => {
  const response = await apiEmails.get('/emails', {
    params: {
      domain_id: domainId || undefined,
      q: q || undefined,
      type: type || undefined,
      page,
      per_page: perPage,
    },
  });
  return response.data;
};

/** GET /emails/domains — the project_ids that have messages. */
export const listEmailDomains = async () => {
  const response = await apiEmails.get('/emails/domains');
  return response.data;
};

/** GET /emails/{id} */
export const getEmail = async (emailId) => {
  const response = await apiEmails.get(`/emails/${emailId}`);
  return response.data;
};

/** DELETE /emails/{id} */
export const deleteEmail = async (emailId) => {
  const response = await apiEmails.delete(`/emails/${emailId}`);
  return response.data;
};

/** PATCH /emails/{id} — mark a message handled (or not). */
export const setEmailHandled = async (emailId, handled) => {
  const response = await apiEmails.patch(`/emails/${emailId}`, { handled });
  window.dispatchEvent(new Event(ALERTS_CHANGED));
  return response.data;
};

/** GET /emails/alert-summary — unhandled reader feedback + contact form messages:
    {unhandled, by_type, by_domain, by_type_domain, latest_at}. */
export const getAlertSummary = async () => {
  const response = await apiEmails.get('/emails/alert-summary');
  return response.data;
};

/* Fired after a handled flag changes, so the header badge recounts at once. */
export const ALERTS_CHANGED = 'inbox-alerts-changed';

/** GET /emails/{id}/fetch — pull the full stored body from Mailgun. */
export const fetchEmailBody = async (emailId) => {
  const response = await apiEmails.get(`/emails/${emailId}/fetch`);
  return response.data;
};

export default apiEmails;
